import React from 'react';
import { DigitalShiplitLinkProps } from "../component";
import "./DigitalShiplit.scss";

function DigitalShiplitLink(props: DigitalShiplitLinkProps) {
    // Create UI link text:
    const viewPDFText: string | undefined = props.currentLinkNumber
        ? `${props.labels.viewShipmentLiterature} ${props.currentLinkNumber}`
        : props.labels.viewShipmentLiterature;

    // Handle click to open bottom sheet via callback
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        if (props.onShiplitClick && props.orderKeyId) {
            props.onShiplitClick(props.orderKeyId);
        }
    };

    return (
        <div className="digital-shiplit__container" onClick={handleClick}>
            <pui-icon
                imgClass="document-medium-full-icon"
                class="digital-shiplit__pui-icon"
            />
            <pui-link
                id="link-to-ingress-into-digital-shiplit"
                class="digital-shiplit__link"
                text={viewPDFText}
            >
            </pui-link>
        </div>
    );
}

export default DigitalShiplitLink;